export type SearchModalProps = {
  show: boolean
  open: () => void
  close: () => void
}

export enum EntityType {
  MODULE = 'MODULE',
  POST = 'POST',
  MEMBERSHIP = 'MEMBERSHIP',
  COMMUNITY = 'COMMUNITY',
  PAGE = 'PAGE'
}

export type Result = {
  id: number
  membershipCode: string
  entityId: number
  entityType: EntityType
  name: string
  description: string
  searchAfter: string[]
  parent?: {
    id: number
    membershipCode: string
    entityType: string
    name: string
  }
  hashId?: string
  parentId?: number
  avatar?: string
}

export type SearchResult = {
  paging: {
    size: number
    total: number
  }
  results: Result[]
}

export type GetGlobalFindParams = {
  membershipSlug: string
  term: string
  size?: number
  searchAfter?: string
}
